export const transition = '0.2s ease';
